import { render, staticRenderFns } from "./TransferTask.vue?vue&type=template&id=ef42a404&scoped=true&"
import script from "./TransferTask.vue?vue&type=script&lang=js&"
export * from "./TransferTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef42a404",
  null
  
)

export default component.exports